module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-7.6d517a54.svg";